<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="payroll.records.records" [menuService]="payrollModuleMenuService">
        <div class="buttons">
            <app-pagination [total]="paginator.total" [current]="paginator.page" (pageChange)="paginator.page = $event">
            </app-pagination>
        </div>
    </app-header>

    <!--No Payrolls-->
    <div *ngIf="!paginator?.total" class="ui segment empty">
        <img style="max-width: 400px" src="/assets/illustrations/piggy-bank.png" />
        <h2 class="ui centered header">{{ 'payroll.records.noClosedPayroll' | translate }}</h2>
    </div>

    <div class="ui table segment" *ngIf="paginator?.total">
        <table class="ui selectable unstackable table">
            <thead>
                <tr>
                    <th>{{ 'payroll.records.period' | translate }}</th>
                    <th>{{ 'payroll.records.periodSpans' | translate }}</th>
                    <th>{{ 'payroll.records.payDay' | translate }}</th>
                    <th>{{ 'payroll.records.type' | translate }}</th>
                    <th>{{ 'payroll.records.state' | translate }}</th>
                    <th class="right aligned">{{ 'payroll.records.obligation' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let payroll of paginator.values"
                    [routerLink]="['/payroll', 'records', 'payrolls', payroll.id]"
                >
                    <td>
                        {{
                            'payroll.records.periodTotal'
                                | translate: { periodNo: payroll.periodNo, totalPeriods: payroll.totalPeriods }
                        }}
                    </td>
                    <td>{{ payroll.startDate | appDate }} - {{ payroll.endDate | appDate }}</td>
                    <td>{{ payroll.chequeDate | appDate }}</td>
                    <td class="collapsing right aligned">
                        <ui-badge>{{
                            (payroll.recurring ? 'payroll.records.recurring' : 'payroll.records.offCycle') | translate
                        }}</ui-badge>
                    </td>
                    <td class="collapsing right aligned">
                        <ui-badge [type]="payroll.state === 'paid' ? 'success' : 'default'">{{
                            payroll.state
                        }}</ui-badge>
                    </td>
                    <td class="right aligned">{{ payroll.liability || 0 | i18nNum: '$' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
